import { render, staticRenderFns } from "./Hue7Box.vue?vue&type=template&id=a0fbcc46&"
import script from "./Hue7Box.vue?vue&type=script&lang=js&"
export * from "./Hue7Box.vue?vue&type=script&lang=js&"
import style0 from "./Hue7Box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports